// @flow
import type {Action} from '../../../state/types'

export type SetLoadingPayload = {
  // TODO: Add payload content
}

const id = 'hospital/SET_LOADING'

export const setLoading = (): Action<SetLoadingPayload> => ({
  type: id,
  payload: {
    // TODO: Add payload content
  }
})

setLoading.id = id
